import { render } from "./welcomeView.vue?vue&type=template&id=13adf69b"
import script from "./welcomeView.vue?vue&type=script&lang=js"
export * from "./welcomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__